import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";

import { BannerWarningContainer } from "./styled";

const BannerWarning = () => {
  return (
    <ComponentErrorBoundary>
      <BannerWarningContainer>
        <p>{"Tá bem vazio aqui! :)"}</p>
        <span>
          Quando você configurar as seções da Billboard com seus grupos, eles
          irão aparecer aqui.
        </span>
      </BannerWarningContainer>
    </ComponentErrorBoundary>
  );
};

export default BannerWarning;
